// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2tjxe","content":"styles_content__3xBXE","selectAll":"styles_selectAll__5Umjv"};